import { useTranslation } from "react-i18next";
import styled from "styled-components"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../ui/tabs"
import { Button, Input, setParamsFilter, Row, Col, message, AspectRatio, Modal, ImportButton } from "./../../../../ui/ot"
import { useEffect, useState, useRef } from "react"
import { Link, useParams, useNavigate, useSearchParams } from "react-router-dom"
import { useItem } from "../../../controllers/ItemController"
import { useBib } from "../../../controllers/BibController"
import { ProTableOt } from "./../../../../ui/ot"
import { useProTableOt } from './../../../../utility/componentOt/controllers/ProtableOtController'
import { ItemForm } from "../item_form";
import { Plus, Pencil, Bookmark } from 'lucide-react';
import { useCRUDController } from "./../../../../ui/classify_structure/CRUDController";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';

const i18nPrefix = "library.bookdetail."
const BookDetail = () => {
    const { t } = useTranslation('translation')
    const [searchParams, setSearchParams] = useSearchParams();
    const bib_biblionumber = searchParams.get('bib_biblionumber');
    const navigate = useNavigate()
    const onBefore = (value) => { console.log('onBefore', value) }
    const onFinish = (value) => { console.log('onFinish', value) }
    const bib_controller = useCRUDController({ apiRoute: "/koha/bib" })
    const {
        BibData,
        getBibData,
        getBibInfoFormat
    } = useBib({
        onBefore,
        onFinish
    })

    useEffect(() => {
        getBibData({
            biblionumber: bib_biblionumber,
        })
        bib_controller.getData({
            biblionumber: bib_biblionumber,
            marcdata: "json"
        })
    }, [])

    const fileInputRef = useRef(null);
    const uploadFile = () => {
        const fileInput = fileInputRef.current;
        const file = fileInput.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
        }
    };
    const bookData = BibData?.find(_ => true)
    return (
        <Row>

            <Col span={24}>
                <ButtonGroup>
                    <Button
                        variant="outline"
                        onClick={() => { navigate(`/library/backstage/AddMARC`) }}
                    >
                        <Plus size={16} />
                        {t("library.backstage.AddMARC.")}
                    </Button>
                    <Button variant="outline" onClick={() => { navigate(`/library/backstage/EditMARC?bib_biblionumber=${bib_biblionumber}`) }}>
                        <Pencil size={16} />
                        {t("library.backstage.EditMARC.")}
                    </Button>
                    <Button variant="outline" onClick={() => navigate('/library/backstage/Circulation/CirculationReserve/' + bib_biblionumber)}>
                        <Bookmark size={16} />
                        預約
                    </Button>
                </ButtonGroup>
            </Col>
            <Input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={uploadFile}
            />
            <Col span={24}>
                <Row>
                    <Col span={20}>
                        <WhiteBox>
                            {
                                getBibInfoFormat().map((value) => {
                                    if (value?.language_name === "bib_title") {
                                        return (
                                            <SubTitle>
                                                {value?.valueKeys.map((keysValue) => bookData?.[keysValue])}
                                            </SubTitle>
                                        )
                                    }
                                    else if (value?.language_name === "Language") {
                                        return (
                                            <div><GrayText>{t(`${i18nPrefix}${value?.language_name}`)}:</GrayText>{value?.valueKeys.map((keysValue) => bookData?.[keysValue]?.['Language'])}</div>
                                        )
                                    }
                                    else {
                                        return <Col span={24}>
                                            <div>
                                                <GrayText>{t(`${i18nPrefix}${value?.language_name}`)}:</GrayText>
                                                {value?.valueKeys.map((keysValue) => {
                                                    if (value?.isJoin) {
                                                        return bookData?.[keysValue].join('、')
                                                    }
                                                    else {
                                                        return bookData?.[keysValue]
                                                    }
                                                })}
                                            </div>
                                        </Col>
                                    }

                                })
                            }
                            <Button type="link" onClick={() => {

                                Modal.info({
                                    width: '1000px',
                                    title: bookData?.bib_title,
                                    okText: "關閉",
                                    content: <>
                                        {
                                            bib_controller.ResponseData.map((value) => {
                                                return (
                                                    <Row>
                                                        <Col span={24}>
                                                            <Row>
                                                                <Col span={24}>
                                                                    <Row>
                                                                        <Col span={3}>
                                                                            leader
                                                                        </Col>
                                                                        <Col span={21}>
                                                                            {value?.metadata?.leader}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Row>
                                                                {value?.metadata?.controlfield.map((field) => {
                                                                    return (
                                                                        <Col span={24}>
                                                                            <Row>
                                                                                <Col span={3}>
                                                                                    {field?.tag}
                                                                                </Col>
                                                                                <Col span={21}>
                                                                                    {field?.text}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    )
                                                                })}
                                                            </Row>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Row gutter={[8, 8]}>
                                                                {value?.metadata?.datafield.map((field) => {
                                                                    return (
                                                                        <Col span={24}>
                                                                            <Row>
                                                                                <Col span={3}>
                                                                                    <Row gutter={[4, 4]}>
                                                                                        <Col>
                                                                                            {field?.tag}
                                                                                        </Col>
                                                                                        <Col>
                                                                                            {field?.ind1}
                                                                                        </Col>
                                                                                        <Col>
                                                                                            {field?.ind2}
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                                <Col span={21}>
                                                                                    <Row>
                                                                                        {
                                                                                            field?.subfield?.map((sub) => {
                                                                                                return (
                                                                                                    <Col span={24}>
                                                                                                        <Row gutter={[4, 4]} >
                                                                                                            <Col>
                                                                                                                {sub?.code}
                                                                                                            </Col>
                                                                                                            <Col>
                                                                                                                {sub?.text}
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                    </Col>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </Row>
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    )
                                                                })}
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                )
                                            })


                                        }
                                    </>

                                })
                            }}>
                                Marc
                            </Button>
                            {/* <div><GrayText>{t(`${i18nPrefix}MARC preview`)}:</GrayText> Show</div>
                            <div><GrayText>{t(`${i18nPrefix}MARC framework`)}:</GrayText> Default</div> */}
                        </WhiteBox>
                    </Col>
                    <Col span={4}>
                        <AspectRatio ratio={3 / 4}>
                            <img src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=" + bookData?.bibitem_isbn} alt="Image" className="h-full w-full rounded-md object-cover" />
                        </AspectRatio>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Tabs defaultValue="0" className="w-full">
                    <TabsList>
                        <TabsTrigger value="0">{t(`${i18nPrefix}Holding`)}</TabsTrigger>
                        {/* <TabsTrigger value="1">{t(`${i18nPrefix}Descriptions`)}</TabsTrigger>
                    <TabsTrigger value="2">{t(`${i18nPrefix}Acquisition details`)}</TabsTrigger>
                    <TabsTrigger value="3">{t(`${i18nPrefix}Images`)}</TabsTrigger> */}
                    </TabsList>
                    <TabsContent value="0">
                        <WhiteBox>
                            <HoldingProTableOt bib_biblionumber={bib_biblionumber} />
                        </WhiteBox>
                    </TabsContent>
                    {/* <TabsContent value="1">
                    <WhiteBox>
                    </WhiteBox>
                </TabsContent>
                <TabsContent value="2">
                    <WhiteBox>
                    </WhiteBox>
                </TabsContent>
                <TabsContent value="3">
                    <WhiteBox>
                        <Row className='mt-2' gutter={[16, 16]} wrap={false} align={'middle'}>
                            <Col>
                                <div>{t(`${i18nPrefix}Upload an image file`)}:</div>
                            </Col>
                            <Col>
                                <Input type={'file'} />
                            </Col>
                        </Row>
                    </WhiteBox>
                </TabsContent> */}
                </Tabs>
            </Col>


        </Row>
    )
}
const HoldingProTableOt = ({
    bib_biblionumber = 0
}) => {
    const { t } = useTranslation('translation')
    const actionRef = useRef()

    const [importDatas, setImportData] = useState([]);
    const [import_modal, set_import_modal] = useState(false);
    const [upload_modal, set_upload_modal] = useState(false)

    const columns = [
        {
            title: t(`${i18nPrefix}Item_type`),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t(`${i18nPrefix}Current library`),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t(`${i18nPrefix}Home library`),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t(`${i18nPrefix}Call_number`),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t(`${i18nPrefix}Status`),
            dataIndex: 'issue_cancheckout',
            key: 'issue_cancheckout',
            render: (text, record, index) => {
                if (record?.issue_cancheckout > 0) {
                    return <>
                        {t(`${i18nPrefix}CanCheckout`)}
                    </>
                } else {
                    return <>
                        {t(`${i18nPrefix}CantCheckout`)}
                    </>
                }
            }
        },
        {
            title: t(`${i18nPrefix}Last seen`),
            dataIndex: 'item_lastseen',
            key: 'item_lastseen',
        },
        {
            title: t(`${i18nPrefix}Date accessioned`),
            dataIndex: 'item_dateaccessioned',
            key: 'item_dateaccessioned',
        },
        {
            title: t(`${i18nPrefix}Date last borrowed`),
            dataIndex: 'item_datelastborrowed',
            key: 'item_datelastborrowed',
        },
        {
            title: t(`${i18nPrefix}Barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
            render: (text, record, index) => {
                return <>
                    <Link style={{
                        color: "blue"
                    }} to={
                        `/library/backstage/BookDetailItems?itemnumber=${record?.item_itemnumber}`
                    }>{text}</Link>
                </>
            }
        },
        {
            title: t(`${i18nPrefix}Copy number`),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        }
    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);  //modal打開或關閉
    const [options, setOptions] = useState( {
        withdrawn_options: [],
        call_number_source_options: [],
        damaged_options: [],
        restricted_options: [],
        notforloan_options: [],
        collection_options: [],
        library_options: [],
        location_options: [],
        shelving_control_number_options: [],
        item_type_options: []
    })
    //勾選的設定，之後可以改一下
    const rowSelection = {
        //不一定都是對id
        // 全選的
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.tag_id); //這個要自己改掉 改成你的id key
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.tag_id);//這個要自己改掉 改成你的id key
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        // 單一勾選
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.tag_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.tag_id
                );
                selectRow = selectRow.filter(
                    (row) => row.tag_id !== record.tag_id
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };

    const changeData = (record) => {
        let data_tmp = importDatas.filter(item => item.index != record.index);
        setImportData(data_tmp);
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest(); //table 重整，包含頁數回到第一頁 
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]); //table 重整，包含頁數回到第一頁 
                setSelectedRowsInfo([]);
            } else if (axiosMode === "import") {
                message.success("匯入成功");
                actionRef.current.reloadAndRest();
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalOpen(false);
        }
    };
    const {
        transformData,
        getItemData,
        postItemData,
        patchItemData,
        deleteItemData,
        exportData,
        importData,
        downloadData,
        overData,
    } = useItem({
        onBefore: () => { },
        onFinish: onFinish
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns
    })
    const {
        getItem_ApiData
    } = useItem({

    })
    useEffect(() => {
        getItem_ApiData({
            itemnumber: "0"
        })
            .then((response) => {
                let datas = response?.data
                let firstData = datas?.find((ele) => true)
                setOptions((pre) => {
                    return {
                        withdrawn_options: firstData?.withdrawn_options,
                        call_number_source_options: firstData?.call_number_source_options,
                        damaged_options: firstData?.damaged_options,
                        restricted_options: firstData?.restricted_options,
                        notforloan_options: firstData?.notforloan_options,
                        collection_options: firstData?.collection_options,
                        library_options: firstData?.library_options,
                        location_options: firstData?.location_options,
                        shelving_control_number_options: firstData?.shelving_control_number_options,
                        item_type_options: firstData?.item_type_options,
                    }
                })
            })
    }, [])
    return (
        <Row>
            <Col span={24}>
                <ProTableOt
                    rowKey={'item_itemnumber'}
                    actionRef={actionRef}
                    columns={columns}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            keyword: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            // "categorycode": "TEST",
                            "field": "keyword",
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        return getItemData({
                            biblionumber: bib_biblionumber,
                            ...newParams
                        })
                    }}

                    toolBarRender={() => {
                        return ([
                            // <Button>{t(`${i18nPrefix}import_collection`)}</Button>,
                            <Button className='example' style={{ background: '#1565C0', color: '#ffffff' }} onClick={e => exportData({ 'itemnumber_id_arr': selectedRowKeys, biblionumber: bib_biblionumber })}>
                                {t(`${i18nPrefix}export_collection`)} <FontAwesomeIcon icon={faFileExport} style={{ marginLeft: '2px' }} />
                            </Button>,
                            <ImportButton
                                handleDownload={e => downloadData()}
                                handleImport={e => {
                                    // e['columns'] = default_column.concat(extra_columns || []); 
                                    e['columns'] = columns
                                    e["biblionumber"] = bib_biblionumber
                                    e["biblio_id"] = bib_biblionumber
                                    importData(e)
                                    set_upload_modal(false)
                                    set_import_modal(false)
                                }}
                                set_upload_modal={set_upload_modal}
                                upload_modal={upload_modal}
                                importData={importDatas}
                                setImportData={setImportData}
                                import_modal={import_modal}
                                set_import_modal={set_import_modal}
                                handleReserve={e => patchItemData(e)}
                                handleOver={e => overData(e)}
                                columns={[...columns, {
                                    title: '保留/覆蓋',
                                    align: 'center',
                                    render: (text, record, index) => {
                                        if (record.type == 'name') {
                                            return (
                                                <>
                                                    <Button type="text" style={{ color: '#4CAF50' }} onClick={e => { changeData(record) }}>保留</Button>
                                                </>)
                                        } else if (record.type == 'both') {
                                            return (
                                                <>
                                                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { patchItemData([record]); changeData(record) }}>覆蓋</Button>
                                                </>
                                            )
                                        }
                                    }
                                }]}
                            />,
                        ])
                    }}
                    check={check}
                    setCheck={setCheck}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        ...rowSelection,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo
                    }}

                    propsPatchOnBefore={(record) => {
                        return { ...record }
                    }}
                    PropsPatchForm={<ItemForm
                    propsOptions={options}
                    isPropsOptions={true}
                    />}
                    propsUseData={() => {
                        return {
                            postData: (data) => {
                                let newData = data?.map((val) => {
                                    return {
                                        ...val,
                                        biblionumber: bib_biblionumber,
                                        biblio_id: bib_biblionumber
                                    }
                                })
                                postItemData(newData)
                            },
                            patchData: patchItemData,
                            deleteData: (data) => {
                                console.log({ data })
                                let newdeleteData = data?.map((val) => {
                                    return {
                                        ...val,
                                        itemnumber: val?.item_itemnumber,
                                    }
                                })
                                deleteItemData(newdeleteData)
                            },
                        }
                    }}
                    propsPatch={true}
                    propsPatchProcess={(record) => {
                        let newRecord = transformData(record)
                        return { ...newRecord }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsDelete={true}
                    propsPatchOnFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}

                    propsPost
                    // propsPostOnBefore
                    initialValues={
                        {
                            biblionumber: bib_biblionumber
                        }
                    }
                    propsWidth={1000}
                    formMode={true}
                />
            </Col>
        </Row>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: 100%;
`

const GrayText = styled.span`
color: #929292;
`

export default BookDetail